import * as actionTypes from '../constants/actionTypes';
import { updateObject } from '../../../../shared/utils';

const initialState = {
  customForm: null,
  customFormError: null,
  customFormLoading: false,

  updateFormResult: null,
  updateFormError: null,
  updateFormLoading: false,

  mappingObjectNames: null,
  mappingObjectNamesError: null,
  mappingObjectNamesLoading: false,

  mappings: null,
  mappingsError: null,
  mappingsLoading: false,
};

const getCustomFormStart = (state, action) => {
  return updateObject(state, {
    customForm: null,
    customFormError: null,
    customFormLoading: true,
  });
};

const getCustomFormSuccess = (state, action) => {
  return updateObject(state, {
    customForm: action.data,
    customFormError: null,
    customFormLoading: false,
  });
};

const getCustomFormFail = (state, action) => {
  return updateObject(state, {
    customForm: null,
    customFormError: action.error,
    customFormLoading: false,
  });
};

const updateFormStart = (state, action) => {
  return updateObject(state, {
    updateFormResult: null,
    updateFormError: null,
    updateFormLoading: true,
  });
};

const updateFormSuccess = (state, action) => {
  return updateObject(state, {
    updateFormResult: action.data,
    updateFormError: null,
    updateFormLoading: false,
  });
};

const updateFormFail = (state, action) => {
  return updateObject(state, {
    updateFormResult: null,
    updateFormError: action.error,
    updateFormLoading: false,
  });
};

const getMappingObjectNamesStart = (state, action) => {
  return updateObject(state, {
    mappingObjectNames: null,
    mappingObjectNamesError: null,
    mappingObjectNamesLoading: true,
  });
};

const getMappingObjectNamesSuccess = (state, action) => {
  return updateObject(state, {
    mappingObjectNames: action.data,
    mappingObjectNamesError: null,
    mappingObjectNamesLoading: false,
  });
};

const getMappingObjectNamesFail = (state, action) => {
  return updateObject(state, {
    mappingObjectNames: null,
    mappingObjectNamesError: action.error,
    mappingObjectNamesLoading: false,
  });
};

const getMappingsStart = (state, action) => {
  return updateObject(state, {
    mappings: null,
    mappingsError: null,
    mappingsLoading: true,
  });
};

const getMappingsSuccess = (state, action) => {
  return updateObject(state, {
    mappings: action.data,
    mappingsError: null,
    mappingsLoading: false,
  });
};

const getMappingsFail = (state, action) => {
  return updateObject(state, {
    mappings: null,
    mappingsError: action.error,
    mappingsLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CUSTOM_FORM_GET_CUSTOM_FORM_FORM_START:
      return getCustomFormStart(state, action);
    case actionTypes.CUSTOM_FORM_GET_CUSTOM_FORM_FORM_SUCCESS:
      return getCustomFormSuccess(state, action);
    case actionTypes.CUSTOM_FORM_GET_CUSTOM_FORM_FORM_FAIL:
      return getCustomFormFail(state, action);

    case actionTypes.CUSTOM_FORM_UPDATE_FORM_START:
      return updateFormStart(state, action);
    case actionTypes.CUSTOM_FORM_UPDATE_FORM_SUCCESS:
      return updateFormSuccess(state, action);
    case actionTypes.CUSTOM_FORM_UPDATE_FORM_FAIL:
      return updateFormFail(state, action);

    case actionTypes.CUSTOM_FORM_GET_OBJECT_NAMES_START:
      return getMappingObjectNamesStart(state, action);
    case actionTypes.CUSTOM_FORM_GET_OBJECT_NAMES_SUCCESS:
      return getMappingObjectNamesSuccess(state, action);
    case actionTypes.CUSTOM_FORM_GET_OBJECT_NAMES_FAIL:
      return getMappingObjectNamesFail(state, action);

    case actionTypes.CUSTOM_FORM_GET_MAPPINGS_START:
      return getMappingsStart(state, action);
    case actionTypes.CUSTOM_FORM_GET_MAPPINGS_SUCCESS:
      return getMappingsSuccess(state, action);
    case actionTypes.CUSTOM_FORM_GET_MAPPINGS_FAIL:
      return getMappingsFail(state, action);

    default:
      return state;
  }
};

export default reducer;
